export default __webpack_public_path__ + "static/media/brian.png.webp";